import React, { Fragment, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/dist/react/index.js'
import { SpeedInsights } from '@vercel/speed-insights/dist/react/index.js'
import { apiEndpoint } from './prismic-configuration'
import { Home, Preview, NotFound, Cv } from './pages'
import GoogleAnalytics from './components/GoogleAnalytics'
import { isLightTheme } from './utils/siteTheme'

function SiteThemeClass() {
  const location = useLocation()

  useEffect(() => {
    const className = 'theme-light'
    document.documentElement.classList.toggle(className, isLightTheme())
    document.body.classList.toggle(className, isLightTheme())

    return () => {
      document.documentElement.classList.remove(className)
      document.body.classList.remove(className)
    }
  }, [location])

  return null
}

/**
 * Main application component
 */
const App = (props) => {
  const repoNameArray = /([^/]+)\.cdn\.prismic\.io\/api/.exec(apiEndpoint)
  const repoName = repoNameArray?.[1]

  return (
    <Fragment>
      <Helmet>
        {repoName && (
          <script
            async
            defer
            src={`//static.cdn.prismic.io/prismic.js?repo=${repoName}&new=true`}
          />
        )}
      </Helmet>

      <BrowserRouter>
        <SiteThemeClass />
        <GoogleAnalytics />
        <Switch>
          <Route exact path="/" component={Home} />

          {/* allow both /preview and /preview/ */}
          <Route path={['/preview', '/preview/']} component={Preview} />

          {/* ✅ allow both /cv and /cv/ */}
          <Route path={['/cv', '/cv/']} component={Cv} />

          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>

      <Analytics />
      <SpeedInsights />
    </Fragment>
  )
}

export default App
